import { gql } from '@apollo/client';

const ILT_QUERY = gql`
    query instructorLedTraining( $iltID: UUID! ) {
        instructorLedTraining( iltID: $iltID ){
            id
            companyId
            defaultSessionName
            sessions {
                id
                companyId
                instructorLedTrainingId
                locales {
                    locale
                    name
                }
                instructors {
                    id
                }
                completionCodes {
                    id
                } 
                completionCount
                filledSeats
                status
                maxSeats
                timezone
                meetingUrl
                registrationUrl
                registrationOpenAt
                registrationCloseAt
                sessionStartAt
                sessionEndAt
                createdAt
                updatedAt
                canceledAt
                address {
                    id
                    companyId
                    label
                    name
                    addressLine1
                    addressLine2
                    locality
                    administrativeArea
                    postalCode
                    country {
                        id
                        code
                        name
                    }
                    comment
                    createdAt
                    updatedAt
                }
            }
        }
    }
`;

export default ILT_QUERY;